import { render, staticRenderFns } from "./BaseNickname.vue?vue&type=template&id=5d3dfec2&scoped=true&"
import script from "./BaseNickname.vue?vue&type=script&lang=js&"
export * from "./BaseNickname.vue?vue&type=script&lang=js&"
import style0 from "./BaseNickname.vue?vue&type=style&index=0&id=5d3dfec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3dfec2",
  null
  
)

export default component.exports